















import { computed, defineComponent, PropType } from '@vue/composition-api';
import NgoItem from '@/components/past-module/ngo-item.vue';
import { PastItemType } from '@/types/past';
import dayjs from 'dayjs';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'home',
  components: {
    NgoItem,
  },
  props: {
    pastItem: {
      type: Object as PropType<PastItemType>,
      required: true,
    },
    index: Number,
  },
  setup() {
    const duration = computed((props) => {
      const { startDate, endDate } = props.pastItem;
      const start = dayjs(startDate).format('YYYY/MM/DD');
      const end = dayjs(endDate).format('YYYY/MM/DD');
      const period = i18n('第{{index}}期', { index: props.index });
      return `${period} ${start} - ${end}`;
    });
    return {
      duration,
    };
  },
});
